// The CSV file format (platform П12): one manifest for the whole product — a semicolon, CRLF, a BOM and a guard against formulas.

/** The separator of the format: a semicolon, so a comma inside a cell stays a comma. */
export const CSV_SEPARATOR = ';';
/** The line ending of the format: CRLF, as Excel expects. */
export const CSV_EOL = '\r\n';
/** The mark at the start of the file: without it Excel reads a UTF-8 file as cp1251. */
export const CSV_BOM = '\uFEFF';

/** A value that is entirely a number: it is not a formula, so it needs no guard. */
const NUMBER = /^[+-]?\d+(\.\d+)?$/;
/** The characters Excel reads as the start of a formula. */
const FORMULA = '=+-@\t\r';

/**
 * Protects a cell from being read as a formula: a value that starts with `=`, `+`, `-`, `@`, a tab or a carriage
 * return gets an apostrophe in front. A number is left alone — `-500` is a number, `+7 999 123-45-67` is not.
 */
export function csvGuard(value: string): string {
  if (!value) return value;
  if (!FORMULA.includes(value[0]!)) return value;
  return NUMBER.test(value.trim()) ? value : `'${value}`;
}

/** Wraps a cell in quotes when it holds a separator, a quote or a line break; the quotes inside are doubled. */
export function csvCell(value: string): string {
  return /[";\r\n]/.test(value) ? `"${value.replace(/"/g, '""')}"` : value;
}

/** A cell of the file: guarded against formulas and quoted when it needs it. */
export function csvText(value: string): string {
  return csvCell(csvGuard(value));
}

/** The whole file: the BOM, then the header and the rows, one per line. */
export function csvFile(rows: string[][]): string {
  return CSV_BOM + rows.map((r) => r.map(csvText).join(CSV_SEPARATOR)).join(CSV_EOL);
}
